import { useSetRecoilState } from "recoil";
import { crudSkillsAtom, skillsAtom } from "../atoms/skills.atom";
import SkillsAPI from "../api/skills.api";
import toast from "react-hot-toast";

const useSkillsAction = () => {
  const setSkillsCrud = useSetRecoilState(crudSkillsAtom);
  const setSkills = useSetRecoilState(skillsAtom);

  const createSkill = async (data, cb) => {
    setSkillsCrud((prevValues) => ({ ...prevValues, loading: true }));
    try {
      const response = await SkillsAPI.createSkill(data);
      if (cb) {
        cb(response);
      }
      setSkillsCrud((prevValues) => ({
        ...prevValues,
        loading: false,
        status: response.status,
      }));
    } catch (error) {
      setSkillsCrud((prevValues) => ({
        ...prevValues,
        loading: false,
        message: "Error al crear competencia",
        status: 500,
        error: JSON.stringify(error),
      }));
    }
  };

  const paginateSkills = async ({ page = 1, limit = 10, search = null, clientId = '' }, cb) => {
    setSkills((prevValues) => ({ ...prevValues, loading: true }));
    try {
      let params = null;
      params = {
        clientId,
        paginationParams: { page, limit }
      };
      if (search) params.paginationParams.search = [search];
      const { data } = await SkillsAPI.paginateSkills(params);
      if (cb) {
        cb(data);
      }
      setSkills((prevValues) => ({ ...prevValues, loading: false, payload: data?.data || [], total: data?.total || 0 }));
    } catch (error) {
      setSkillsCrud((prevValues) => ({
        ...prevValues,
        loading: false,
        message: "Error al listar competencia",
        status: 500,
        error: JSON.stringify(error),
      }));
    }
  }

  const updateSkill = async(data,cb) =>{
    setSkillsCrud((prevValues) => ({ ...prevValues, loading: true }));
    try {
      const response = await SkillsAPI.updateSkills(data);
      if(cb){
        cb(response)
      }
      setSkillsCrud((prevValues) => ({
        ...prevValues,
        loading: false,
        status: response.status,
      }));
      
    } catch (error) {
      toast.error('Error al editar competencia', {duration:4000})
      setSkillsCrud((prevValues) => ({
        ...prevValues,
        loading: false,
        message: "Error al editar competencia",
        status: 500,
        error: JSON.stringify(error),
      }));
    }
  }

  const deleteSkill = async(id, cb)=>{
    setSkillsCrud((prevValues) => ({ ...prevValues, loading: true }));
    try {
      const response = await SkillsAPI.deleteSkills({id});
      if(cb){
        cb(response)
      }
      setSkillsCrud((prevValues) => ({ ...prevValues, loading: false, status: response.status })); 
    } catch (error) {
      toast.error('Error al eliminar competencia', {duration:4000})
      setSkillsCrud((prevValues) => ({
        ...prevValues,
        loading: false,
        message: "Error al borrar competencia",
        status: 500,
        error: JSON.stringify(error),
      }));
    }
  }

  const listSkills = async(cb)=>{
    setSkillsCrud((prevValues) => ({ ...prevValues, loading: true }));
    try {
      const response = await SkillsAPI.listSkills()
        return response

    } catch (error) {
      setSkillsCrud((prevValues) => ({
        ...prevValues,
        loading: false,
        message: "Error al listar competencias",
        status: 500,
        error: JSON.stringify(error),
      }));
    }
  }


  return {
    createSkill,
    paginateSkills,
    deleteSkill,
    updateSkill,
    listSkills
  }
};

export {useSkillsAction}